const HallsService = {
  getHallNumber(hallId) {
    if (hallId === 'H1') {
      return '1';
    } else if (hallId === 'H2') {
      return '2';
    } else if (hallId === 'H2') {
      return '2';
    } else if (hallId === 'H3') {
      return '3';
    } else if (hallId === 'H4') {
      return '4';
    } else if (hallId === 'H5') {
      return '5';
    } else if (hallId === 'H6') {
      return '6';
    } else if (hallId === 'H7') {
      return '7';
    } else if (hallId === 'H8') {
      return '8';
    } else if (hallId === 'H9') {
      return '9';
    } else if (hallId === 'H10') {
      return '10';
    } else if (hallId === 'GH1') {
      return '1';
    } else {
      return '';
    }
  },
};

export default HallsService;
